import React from 'react';
import { Route, Routes, useLocation } from "react-router-dom";
import AuthProvider from "../session/AuthProvider";
import AuthenticatedPage from "../session/AuthenticatedPage";
import NotFound from "../routes/404/NotFound";
import AdminLoginPage from "../routes/admin-login/AdminLoginPage";
import AdminHome from "../routes/home/AdminHome";
import AdminNav from "../nav/AdminNav";
import { UploadProgressContextProvider } from "nood-comp/src/comp/upload-progress/UploadProgressContext";
import { routes } from "../routes/routes";
import OrgIndex from "../routes/orgs/OrgIndex";
import NoodleModalProvider from "nood-comp/src/comp/modal/NoodleModalProvider";
import ClosestElementRegistry from "nood-comp/src/util/listener/ClosestElementRegistry";
import MainContent from "src/nav/MainContent";
import Application from "src/routes/app/Application";
import IAppContextProvider from "nood-comp/src/context-providers/IAppContextProvider";
import EventIndex from "src/routes/event/EventIndex";
import AppContextProvider from "src/contexts/AppContextProvider";
import PublicPage from "src/session/PublicPage";
import AdminInviteIndex from "src/routes/admin-invite/AdminInviteIndex";
import ErrorBoundary from "nood-comp/src/comp/ErrorBoundary";
import ModalImageViewerProvider from "nood-comp/src/comp/ui/image-viewer/ModalImageViewerProvider";
import ToasterWrapper from "src/app/ToasterWrapper";
var RequestInvites = /*#__PURE__*/React.lazy(function () {
  return import("../routes/request_invite/RequestInvites");
});
var RequestInvite = /*#__PURE__*/React.lazy(function () {
  return import("../routes/request_invite/RequestInvite");
});
var AdminGroupsNew = /*#__PURE__*/React.lazy(function () {
  return import("../routes/admin-groups/AdminGroups.New");
});
var AdminGroup = /*#__PURE__*/React.lazy(function () {
  return import("../routes/admin-group/AdminGroup");
});
var Files = /*#__PURE__*/React.lazy(function () {
  return import("../routes/files/Files");
});
var File = /*#__PURE__*/React.lazy(function () {
  return import("../routes/file/File");
});
var AdminGroups = /*#__PURE__*/React.lazy(function () {
  return import("../routes/admin-groups/AdminGroups");
});
var AdminMeEditPage = /*#__PURE__*/React.lazy(function () {
  return import("../me/AdminMeEditPage");
});
var AdminMeEditProfilePage = /*#__PURE__*/React.lazy(function () {
  return import("../me/AdminMeEditProfilePage");
});
var AdminMeEditPasswordPage = /*#__PURE__*/React.lazy(function () {
  return import("../me/AdminMeEditPasswordPage");
});
var AdminMe = /*#__PURE__*/React.lazy(function () {
  return import("../me/AdminMe");
});
var SettingsPage = /*#__PURE__*/React.lazy(function () {
  return import("../routes/settings/SettingsPage");
});
var SubscriptionPage = /*#__PURE__*/React.lazy(function () {
  return import("../routes/subscription/SubscriptionPage");
});
var User = /*#__PURE__*/React.lazy(function () {
  return import("../routes/user/User");
});
var Admin = /*#__PURE__*/React.lazy(function () {
  return import("../routes/admin/Admin");
});
var Events = /*#__PURE__*/React.lazy(function () {
  return import("../routes/event/Events");
});
var OrgInfo = /*#__PURE__*/React.lazy(function () {
  return import("../routes/user/info/OrgInfo");
});
var OrgEvents = /*#__PURE__*/React.lazy(function () {
  return import("../routes/user/events/OrgEvents");
});
var Audit = /*#__PURE__*/React.lazy(function () {
  return import("src/routes/admin/audit/Audit");
});
export default function App() {
  var location = useLocation();
  return /*#__PURE__*/React.createElement(AuthProvider, null, /*#__PURE__*/React.createElement(AppContextProvider, null, /*#__PURE__*/React.createElement(IAppContextProvider, null, /*#__PURE__*/React.createElement(ClosestElementRegistry, null, /*#__PURE__*/React.createElement(NoodleModalProvider, null, /*#__PURE__*/React.createElement(ModalImageViewerProvider, null, /*#__PURE__*/React.createElement(ToasterWrapper, null), /*#__PURE__*/React.createElement(UploadProgressContextProvider, null, /*#__PURE__*/React.createElement(AdminNav, null), /*#__PURE__*/React.createElement(ErrorBoundary, {
    key: location.pathname
  }, /*#__PURE__*/React.createElement(MainContent, null, /*#__PURE__*/React.createElement(Routes, null, /*#__PURE__*/React.createElement(Route, {
    path: "/login",
    element: /*#__PURE__*/React.createElement(AdminLoginPage, null)
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/",
    element: /*#__PURE__*/React.createElement(AuthenticatedPage, null, /*#__PURE__*/React.createElement(AdminHome, null))
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/me",
    element: /*#__PURE__*/React.createElement(AuthenticatedPage, null, /*#__PURE__*/React.createElement(AdminMe, null))
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/orgs",
    element: /*#__PURE__*/React.createElement(AuthenticatedPage, null, /*#__PURE__*/React.createElement(OrgIndex, null))
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/request_invite/:request_id",
    element: /*#__PURE__*/React.createElement(AuthenticatedPage, null, /*#__PURE__*/React.createElement(RequestInvite, null))
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/request_invites",
    element: /*#__PURE__*/React.createElement(AuthenticatedPage, null, /*#__PURE__*/React.createElement(RequestInvites, null))
  }), /*#__PURE__*/React.createElement(Route, {
    path: routes.admin,
    element: /*#__PURE__*/React.createElement(AuthenticatedPage, null, /*#__PURE__*/React.createElement(Admin, null))
  }, /*#__PURE__*/React.createElement(Route, {
    path: "/admin/groups",
    element: /*#__PURE__*/React.createElement(AuthenticatedPage, null, /*#__PURE__*/React.createElement(AdminGroups, null))
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/admin/groups/new",
    element: /*#__PURE__*/React.createElement(AuthenticatedPage, null, /*#__PURE__*/React.createElement(AdminGroupsNew, null))
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/admin/files",
    element: /*#__PURE__*/React.createElement(AuthenticatedPage, null, /*#__PURE__*/React.createElement(Files, null))
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/admin/files/:file_id",
    element: /*#__PURE__*/React.createElement(AuthenticatedPage, null, /*#__PURE__*/React.createElement(File, null))
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/admin/settings",
    element: /*#__PURE__*/React.createElement(AuthenticatedPage, null, /*#__PURE__*/React.createElement(SettingsPage, null))
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/admin/logs",
    element: /*#__PURE__*/React.createElement(AuthenticatedPage, null, /*#__PURE__*/React.createElement(Audit, null))
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/admin/subscription",
    element: /*#__PURE__*/React.createElement(AuthenticatedPage, null, /*#__PURE__*/React.createElement(SubscriptionPage, null))
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/admin/groups/:group_id",
    element: /*#__PURE__*/React.createElement(AuthenticatedPage, null, /*#__PURE__*/React.createElement(AdminGroup, null))
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/admin/*",
    element: /*#__PURE__*/React.createElement(NotFound, null)
  })), /*#__PURE__*/React.createElement(Route, {
    path: "/admin-invite",
    element: /*#__PURE__*/React.createElement(PublicPage, null, /*#__PURE__*/React.createElement(AdminInviteIndex, null))
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/event",
    element: /*#__PURE__*/React.createElement(AuthenticatedPage, null, /*#__PURE__*/React.createElement(EventIndex, null))
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/app",
    element: /*#__PURE__*/React.createElement(AuthenticatedPage, null, /*#__PURE__*/React.createElement(Application, null))
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/org/:org_id",
    element: /*#__PURE__*/React.createElement(AuthenticatedPage, null, /*#__PURE__*/React.createElement(User, null))
  }, /*#__PURE__*/React.createElement(Route, {
    path: "/org/:org_id/info",
    element: /*#__PURE__*/React.createElement(AuthenticatedPage, null, /*#__PURE__*/React.createElement(OrgInfo, null))
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/org/:org_id/events",
    element: /*#__PURE__*/React.createElement(AuthenticatedPage, null, /*#__PURE__*/React.createElement(OrgEvents, null))
  })), /*#__PURE__*/React.createElement(Route, {
    path: "/me/edit",
    element: /*#__PURE__*/React.createElement(AuthenticatedPage, null, /*#__PURE__*/React.createElement(AdminMeEditPage, null))
  }, /*#__PURE__*/React.createElement(Route, {
    path: routes.edit_profile,
    element: /*#__PURE__*/React.createElement(AuthenticatedPage, null, /*#__PURE__*/React.createElement(AdminMeEditProfilePage, null))
  }), /*#__PURE__*/React.createElement(Route, {
    path: routes.edit_password,
    element: /*#__PURE__*/React.createElement(AuthenticatedPage, null, /*#__PURE__*/React.createElement(AdminMeEditPasswordPage, null))
  })), /*#__PURE__*/React.createElement(Route, {
    path: "*",
    element: /*#__PURE__*/React.createElement(NotFound, null)
  })))))))))));
}